// extracted by mini-css-extract-plugin
export default {"topics-item":"TopicItem_topics-item__zfnRy","title":"TopicItem_title__iETaH","actions":"TopicItem_actions__lHwPZ","icon":"TopicItem_icon__l6+5A"};